import { byId as departmentsById } from '../data/departments.js';

/**
 * The grade sheet.
 *
 * Shown the moment a BEO closes, whether you submitted it or the deadline
 * submitted it for you. The letter is the headline and the five marks under it
 * are the actual content — a grade with no reasoning is a grade nobody learns
 * from, and this game's whole loop is "find out which of the five things you
 * were sloppy about".
 *
 * The standing block underneath is where the rivalry matrix finally becomes
 * visible. Seeing "Banquets +22, Kitchen -13" on the same card, from the same
 * act, is the moment the system explains itself.
 */
export function createGradePanel({ parent, onClose }) {
  const root = document.createElement('div');
  root.className = 'grade';
  root.hidden = true;
  parent.append(root);

  function close() {
    root.hidden = true;
    onClose?.();
  }

  return {
    root,
    get open() {
      return !root.hidden;
    },
    close,

    show({ beo, result, changes, auto }) {
      const marks = result.breakdown
        .map(
          (row) => `<div class="mark">
            <span class="mark-label">${row.label}</span>
            <span class="mark-bar"><i style="width:${Math.round(row.value * 100)}%"
              data-tone="${row.value > 0.85 ? 'good' : row.value > 0.5 ? 'warn' : 'bad'}"></i></span>
            <span class="mark-detail">${row.detail}</span>
            <span class="mark-value">${Math.round(row.value * 100)}%</span>
          </div>`
        )
        .join('');

      const moves = changes
        .filter((change) => Math.abs(change.delta) >= 0.1)
        .sort((a, b) => Math.abs(b.delta) - Math.abs(a.delta))
        .map(
          (change) => `<div class="move" data-tone="${change.delta > 0 ? 'good' : 'bad'}">
            <span>${departmentsById[change.department].name}</span>
            <span>${change.delta > 0 ? '+' : ''}${change.delta.toFixed(1)}</span>
            <span class="move-now">now ${Math.round(change.to)}</span>
          </div>`
        )
        .join('');

      root.innerHTML = `
        <div class="grade-card">
          <header>
            <span class="grade-code">${beo.code} · ${beo.title}</span>
            <div class="grade-letter" data-grade="${result.letter}">${result.letter}</div>
            <span class="grade-score">${Math.round(result.score * 100)}%${
              auto ? ' · graded at the deadline' : ''
            }</span>
          </header>
          <section class="grade-marks">${marks}</section>
          <section class="grade-moves">
            <h4>Where that leaves you</h4>
            ${moves || '<p class="grade-none">Nothing moved.</p>'}
          </section>
          <button class="board-close" type="button">Close  [Esc]</button>
        </div>`;
      root.querySelector('.board-close').addEventListener('click', close);
      root.hidden = false;
    },
  };
}
